module.exports = __webpack_public_path__ + "static/media/game-display-3.1e97a23e.png";